import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '../features/auth/authApi';
import { candidatesApi } from '../features/dashBoard/candidatesApi';
import { getJobsApi } from '../features/dashBoard/getJobsApi';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import {
  authReducer,
  candidatesStatusReducer,
  candidatesJobReducer,
  selectedJobIdReducer,
  createJobRoleSlice,
} from '../store';
import { createJobRoleApi } from '../features/dashBoard/createJobRoleApi';
import { questionsSkillsBankApi } from '@/features/dashBoard/questionsSkillsBankApi';
import { candidatesInterviewApi } from '@/features/dashBoard/candidatesInterviewsApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    candidatesStatus: candidatesStatusReducer,
    [candidatesApi.reducerPath]: candidatesApi.reducer,
    candidatesJobs: candidatesJobReducer,
    [getJobsApi.reducerPath]: getJobsApi.reducer,
    selectedJobId: selectedJobIdReducer,
    [createJobRoleApi.reducerPath]: createJobRoleApi.reducer,
    createJobRole: createJobRoleSlice,
    [questionsSkillsBankApi.reducerPath]: questionsSkillsBankApi.reducer,
    [candidatesInterviewApi.reducerPath]: candidatesInterviewApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(candidatesApi.middleware)
      .concat(getJobsApi.middleware)
      .concat(createJobRoleApi.middleware)
      .concat(questionsSkillsBankApi.middleware)
      .concat(candidatesInterviewApi.middleware),

  // Enable Redux DevTools in development mode
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
